import { Component, ElementRef, inject, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-accordion-section',
    templateUrl: './accordion-section.component.html',
    styleUrls: ['./accordion-section.component.scss'],
    standalone: false
})
export class AccordionSectionComponent implements OnInit {

  elementRef = inject(ElementRef);
  @Input() pageId: string = "";
  @Input() title: string = "";


  tipContainerElement:any;
  tipContainerBtnElement:any;

  constructor() { }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.tipContainerElement = this.elementRef.nativeElement.querySelector(`.accordion__container`);
    this.tipContainerBtnElement = this.elementRef.nativeElement.querySelector(`.accordion .accordion__btn`);
  }

  onExpandToggle() {

    this.tipContainerElement = this.elementRef.nativeElement.querySelector(`.accordion__container`);
    this.tipContainerBtnElement = this.elementRef.nativeElement.querySelector(`.accordion .accordion__btn`);

    if (!this.tipContainerElement) return;

    if (this.tipContainerElement.classList.contains("accordion__container--collapse")) {
      this.tipContainerElement.classList.remove("accordion__container--collapse");
      this.tipContainerElement.classList.add("accordion__container--expand");
    }
    else if (this.tipContainerElement.classList.contains("accordion__container--expand")) {
      this.tipContainerElement.classList.remove("accordion__container--expand");
      this.tipContainerElement.classList.add("accordion__container--collapse");
    }

    this.tipContainerBtnElement.classList.toggle("rotate-180");
    this.tipContainerBtnElement.classList.toggle("btn-light-danger");
    this.tipContainerBtnElement.classList.toggle("btn-light-success");

  }


}
